<template>
	<AlertCard :class="{ 'incoming-animation': showIncomingAnimation }" class="alert-container" v-if="showNotification" :alert="alert" />
	<InboxUnarchiveNotification class="px-4" v-else-if="showUndoArchive" :alert="alert" />
</template>
<script>
import moment from 'moment';
import AlertCard from '@/components/Alerts/AlertCard';
import InboxUnarchiveNotification from '@/components/Inbox/InboxUnarchiveNotification.vue';

const INCOMING_ANIMATION_LENGTH_MS = 5000;
const MAX_SECONDS_AGE_TO_SHOW_ANIMATION = 5;

export default {
	name: 'InboxNotificationsItemDataProvider',
	components: { AlertCard, InboxUnarchiveNotification },
	props: { alert: { type: Object, required: true }, archivedMode: { type: Boolean, required: true } },
	computed: {
		showNotification() {
			return this.archivedMode ? this.alert.archived : !this.alert.archived;
		},
		showUndoArchive() {
			return !this.archivedMode && this.alert.archived;
		},
	},
	mounted() {
		setTimeout(() => {
			const howManySecondsAgoTheAlertWasCreated = moment.duration(moment(new Date()).diff(moment(this.alert.created_at))).asSeconds();
			if (this.alert.created_at && howManySecondsAgoTheAlertWasCreated < MAX_SECONDS_AGE_TO_SHOW_ANIMATION) {
				this.showIncomingAnimation = true;
				setTimeout(() => {
					this.showIncomingAnimation = false;
				}, INCOMING_ANIMATION_LENGTH_MS);
			}
		}, 10);
	},
	data() {
		return { showIncomingAnimation: false };
	},
};
</script>
<style scoped lang="scss">
.alert-container {
	::v-deep {
		.notification-container,
		.notification-preview-container {
			border: unset;
			max-width: 100%;
			cursor: pointer;
			transition: 0.3s;
			box-shadow: unset;
			border-radius: unset;
			background: var(--white);
			border-bottom: 1px solid #e8e8e8;
			&:hover {
				transition: 0.3s;
				background: #f7f7f7;
			}
		}
	}
}
.incoming-animation {
	::v-deep {
		.notification-container,
		.notification-preview-container {
			background-color: #6b6bcc20;
			transition: background-color 1000ms linear;
		}
	}
}
</style>
